import React, { useEffect, useRef, useState } from "react";
import ProgressBar from "../../ProgressBarStep";
import "./style3.css"; // Import the CSS file
import { useDispatch } from "react-redux";
import { UploadMediaRequestAPI } from "../../../../../../Store/Action/mediaAction";
import { BASE_URL } from "../../../../../../Constants/AppConstants";
import { getUserDetailsInOnboarding } from "../../../../../../Store/Action/onboardingAction";
import Icons from "../../../../../../Config/Images";

const FileUpload = React.forwardRef(
  (
    {
      label,
      value,
      onChange,
      error,
      errors,
      onmouseoutFunction,
      preview,
      fileType,
      fieldKey,
    },
    ref
  ) => (
    <div className="questionsUpload" onBlur={onmouseoutFunction}>
      <p className="paraUpload">{label}</p>
      <div
        className="custom-file-upload"
        onClick={() => ref.current && ref.current.click()}
        style={{ position: "relative" }}
      >
        {preview?.url &&
          (preview.type === ".pdf" ? (
          // (preview.type === "application/pdf" ? (
            <img
              src={Icons?.default_pdf_icon} // Replace with your PDF icon path
              alt="PDF Uploaded"
              className="file-upload-preview-pdf"
            />
          ) : (
            <img
              src={preview.url}
              alt="Image Uploaded"
              className="file-upload-preview"
            />
          ))}
        <input
          type="text"
          placeholder={preview?.url ? "" : "No file chosen"}
          readOnly
          // className="file-input-text"
          className={errors?.[fieldKey] ? "error-input" : "file-input-text"} // Apply error class
          value={value || ""}
        />
        <input
          type="file"
          ref={ref}
          className="file-input-hidden"
          accept=".pdf,.jpg,.jpeg,.png"
          required
          onChange={onChange}
        />
        {/* {preview} */}
        <button type="button" className="browse-button">
          Browse
        </button>
      </div>

      {error && <div className="error">{error}</div>}
    </div>
  )
);

const UploadDocument = ({
  text,
  formData,
  setFormData,
  errors,
  setErrors,
  handleFormFieldChange,
  userOnboardingDetails,
  isRequireFields,
}) => {
  const dispatch = useDispatch();
  const [panCardFile, setPanCardFile] = useState(null);
  const [companyDocumentFile, setCompanyDocumentFile] = useState(null);
  const [gstDocumentFile, setGstDocumentFile] = useState(null);
  const [visitingCardFile, setVisitingCardFile] = useState(null);
  const [tdsDeclarationFile, setTdsDeclarationFile] = useState(null);
  const [uploadedFileType, setUploadedFileType] = useState({});

  const handleFileChange = (ref, fieldName) => {
    const file = ref.current?.files[0];

    if (file) {
      // Clear any previous errors
      setErrors((prevErrors) => ({
        ...prevErrors,
        [fieldName]: "",
      }));
    }

    const selectedFiles = [file]; // Directly use the File object

    dispatch(
      UploadMediaRequestAPI(
        selectedFiles,
        "onboardingDocuments",
        false,
        (result) => {
          if (result.status) {
            const fileType = result?.data?.[0]?.file_storage_type || "";
            const fileUrl = result?.data?.[0]?.file_url || "";

            // Store both URL and type for preview
            const fileData = { url: fileUrl, type: fileType };

            switch (fieldName) {
              case "panCardFile":
                setPanCardFile(fileData);
                break;
              case "GSTDocumentFile":
                setGstDocumentFile(fileData);
                break;
              case "companyDocumentFile":
                setCompanyDocumentFile(fileData);
                break;
              case "visitingCardFile":
                setVisitingCardFile(fileData);
                break;
              case "tdsDeclarationFile":
                setTdsDeclarationFile(fileData);
                break;
              default:
                break;
            }

            // Store file ID in form data
            setFormData((prev) => ({
              ...prev,
              [fieldName]: result.data[0].file_storage_id,
            }));

            // Clear any previous errors
            setErrors((prevErrors) => ({
              ...prevErrors,
              [fieldName]: "",
            }));
          }
        }
      )
    );
  };

  useEffect(() => {
    dispatch(
      getUserDetailsInOnboarding({}, (result) => {
        if (result && Array.isArray(result?.data)) {
          const panCardUploadInfoVal = result?.data?.find(
            (item) => item?.generic_name === "uploadPanCard"
          );

          setPanCardFile({
            url:
              panCardUploadInfoVal?.upload_document_images?.[0]
                ?.product_image_url || "",
            type:
              panCardUploadInfoVal?.upload_document_images?.[0]
                ?.file_storage_type || "",
          });

          const gstInUploadInfoVal = result?.data?.find(
            (item) => item?.generic_name === "uploadGstDocument"
          );
          setGstDocumentFile({
            url:
              gstInUploadInfoVal?.upload_document_images?.[0]
                ?.product_image_url || "",
            type:
              gstInUploadInfoVal?.upload_document_images?.[0]
                ?.file_storage_type || "",
          });

          const companyOfficialDocumentUploadInfoVal = result?.data?.find(
            (item) => item?.generic_name === "companyOfficialDocument"
          );
          setCompanyDocumentFile({
            url:
              companyOfficialDocumentUploadInfoVal?.upload_document_images?.[0]
                ?.product_image_url || "",
            type:
              companyOfficialDocumentUploadInfoVal?.upload_document_images?.[0]
                ?.file_storage_type || "",
          });

          const visitingCardUploadInfoVal = result?.data?.find(
            (item) => item?.generic_name === "visitingCard"
          );
          setVisitingCardFile({
            url:
              visitingCardUploadInfoVal?.upload_document_images?.[0]
                ?.product_image_url || "",
            type:
              visitingCardUploadInfoVal?.upload_document_images?.[0]
                ?.file_storage_type || "",
          });

          const tdsDeclarationUploadInfoVal = result?.data?.find(
            (item) => item?.generic_name === "tdsDeclaration"
          );
          setTdsDeclarationFile({
            url:
              tdsDeclarationUploadInfoVal?.upload_document_images?.[0]
                ?.product_image_url || "",
            type:
              tdsDeclarationUploadInfoVal?.upload_document_images?.[0]
                ?.file_storage_type || "",
          });
        }
      })
    );
  }, []);
  // }, [dispatch, handleFileChange]);

  const panCardRef = useRef(null);
  const companyDocumentRef = useRef(null);
  const GSTDocumentRef = useRef(null);
  const visitingCardRef = useRef(null);
  const tdsDeclarationRef = useRef(null);

  return (
    <div className="mainContainer">
      <h4 className="h4">{text}</h4>

      <div className="formContainer">
        <ProgressBar currentStep={2} />

        <div className="formDivUpload">
          {/* ✅ GST = Yes → show GST doc only */}
          {formData.gstCheckbox === "Yes" && (
            <FileUpload
              label={
                <>
                  11. Please upload your GSTIN document{" "}
                  {isRequireFields?.gstDocument && (
                    <span className="asterisk-personal-info">*</span>
                  )}
                </>
              }
              ref={GSTDocumentRef}
              preview={gstDocumentFile}
              onChange={() =>
                handleFileChange(GSTDocumentRef, "GSTDocumentFile")
              }
              onmouseoutFunction={handleFormFieldChange}
              error={errors.GSTDocumentFile}
              fieldKey="GSTDocumentFile"
              errors={errors}
            />
          )}

          {/* ✅ GST = No → show PAN + company doc + visiting card */}
          {formData.gstCheckbox === "No" && (
            <>
              <FileUpload
                label={
                  <>
                    11. Please upload your PAN card{" "}
                    {isRequireFields?.panCardDocument && (
                      <span className="asterisk-personal-info">*</span>
                    )}
                  </>
                }
                ref={panCardRef}
                preview={panCardFile}
                onChange={() => handleFileChange(panCardRef, "panCardFile")}
                onmouseoutFunction={handleFormFieldChange}
                error={errors.panCardFile}
                fieldKey="panCardFile"
                errors={errors}
              />

              {/* <FileUpload
                label={
                  <>
                    13. Please upload your company's official document{" "}
                    {isRequireFields?.companyOfficialDocument && (
                      <span className="asterisk-personal-info">*</span>
                    )}
                  </>
                }
                ref={companyDocumentRef}
                preview={companyDocumentFile}
                onChange={() =>
                  handleFileChange(companyDocumentRef, "companyDocumentFile")
                }
                onmouseoutFunction={handleFormFieldChange}
                error={errors.companyDocumentFile}
                fieldKey="companyDocumentFile"
                errors={errors}
              /> */}

              <FileUpload
                label={
                  <>
                    12. Could you upload your visiting card?{" "}
                    {isRequireFields?.visitingCard && (
                      <span className="asterisk-personal-info">*</span>
                    )}
                  </>
                }
                ref={visitingCardRef}
                preview={visitingCardFile}
                onChange={() =>
                  handleFileChange(visitingCardRef, "visitingCardFile")
                }
                onmouseoutFunction={handleFormFieldChange}
                error={errors.visitingCardFile}
                fieldKey="visitingCardFile"
                errors={errors}
              />
            </>
          )}

          {/* ✅ TDS — shown for both if turnOver = Yes */}
          {formData.turnOver === "Yes" && (
            <FileUpload
              label={
                <>
                  {formData.gstCheckbox === "No" ? "13." : "12."} Please upload
                  your TDS declaration{" "}
                  {isRequireFields?.tdsDeclaration && (
                    <span className="asterisk-personal-info">*</span>
                  )}
                </>
              }
              ref={tdsDeclarationRef}
              preview={tdsDeclarationFile}
              onChange={() =>
                handleFileChange(tdsDeclarationRef, "tdsDeclarationFile")
              }
              onmouseoutFunction={handleFormFieldChange}
              error={errors.tdsDeclarationFile}
              fieldKey="tdsDeclarationFile"
              errors={errors}
            />
          )}

          <div className="info">
            <p>
              Upload documents in JPEG or PDF format, no longer than 10 MB in
              size.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UploadDocument;
